<template>
  <div class="swiper-no-swiping w-100 justify-space-end d-flex flex-column">
    <div class="d-flex w-100 flex-column gap-xs align-center">
      <h1 class="font-lg">Permissions isLocationDisabled</h1>
      <p class="font-sm align-start">We need permissions</p>

      <ion-button
        v-if="!isWeb"
        @click="handleRequestPermissions"
        fill="solid"
        expand="block"
        size="large"
        color="accent"
        class="text-lg text-weight-bold w-100"
      >
        Request location permissions
      </ion-button>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { IonButton } from '@ionic/vue';
  import { onMounted, ref } from 'vue';
  import { useToast } from '@/composables/useToast';
  import { getDeviceInfo } from '@/plugins/device';
  import { requestPermissions } from '@/plugins/geolocalization';

  const { showToast } = useToast();

  const isLoading = ref(false);
  const isWeb = ref(false);

  const handleRequestPermissions = async () => {
    try {
      isLoading.value = true;
      await requestPermissions();
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    } finally {
      isLoading.value = false;
    }
  };

  onMounted(async () => {
    const device = await getDeviceInfo();
    if (device.platform === 'web') {
      isWeb.value = true;
    }
  });
</script>

<style lang="css" scoped>
  .swiper {
    width: 100% !important;
    height: 100%;
  }
</style>
